import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Table from "../../../../Componets/Table";
import tables from "../../../../Data/Tables/Settings/Roles/tables";
import headers from "../../../../Data/Tables/Settings/Roles/headers";
import roles from "../../../../Data/roles.json";
import toast from "react-hot-toast";
import ActionButton from "../../../../Componets/Buttons/action";

const SettingRolesTable = () => {
  let header = headers;
  let head = tables;

  const [body, setBody] = useState();

  const fetchData = async () => {
    try {
      let data = [];

      roles?.map((value, index) => {
        data?.push({
          Name: value?.name,
          "Created By": value?.created,
          Action: <ActionButton edit={`/`} delete="/" />,
        });
      });

      setBody(data);
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  const formdata = async (data) => {
    console.log(data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header header={header} formdata={formdata}>
      <Table head={head} body={body} />
      <ActionButton />
    </Header>
  );
};

export default SettingRolesTable;
